import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const CUSTOMER_TOKEN_KEY = "sorciere_customer_token";
export const ADMIN_TOKEN_KEY = "sorciere_admin_token";

api.interceptors.request.use((config) => {
  const isAdmin = (config.url || "").includes("/admin/");
  const token = isAdmin
    ? localStorage.getItem(ADMIN_TOKEN_KEY)
    : localStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const eur = (cents) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
    (cents || 0) / 100,
  );

export const setCustomerToken = (t) =>
  localStorage.setItem(CUSTOMER_TOKEN_KEY, t);
export const getCustomerToken = () => localStorage.getItem(CUSTOMER_TOKEN_KEY);
export const clearCustomerToken = () =>
  localStorage.removeItem(CUSTOMER_TOKEN_KEY);

export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export default api;
